import { Dialog, DialogButton, DialogContentText } from '@/components/Dialog';
import { MAX_SELECTED_CURVES, MAX_SELECTED_SYMBOLS } from '@/constants/constants';
import { SELECTOR_MODES } from '@/features/SymbolSelector/store/symbolSelector.slice';

const LimitDialog = ({
  handleClose,
  open,
  selectorMode = SELECTOR_MODES.NEUTRAL
}: {
  handleClose: () => void;
  open: boolean;
  selectorMode?: SELECTOR_MODES;
}) => {
  const isForwardCurve = selectorMode === SELECTOR_MODES.FORWARD_CURVE;
  return (
    <Dialog
      buttons={<DialogButton onClick={handleClose}>Ok</DialogButton>}
      open={open}
      title='Too many!'
      onClose={handleClose}
    >
      <DialogContentText>
        {isForwardCurve
          ? `Please select fewer than ${MAX_SELECTED_CURVES} curves.`
          : `Please select fewer than ${MAX_SELECTED_SYMBOLS}.`}
      </DialogContentText>
    </Dialog>
  );
};

export default LimitDialog;
